/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AINA Agents API
 * Subset of AI agents service used by One App (session APIs).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  LoadUserSessionRequest,
  LoadUserSessionResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Resolves landing agent (e.g. AINA_VOICE vs AINA_MENTOR) and session context.
 * @summary Load user session
 */
export const loadUserSession = (
  loadUserSessionRequest: LoadUserSessionRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<LoadUserSessionResponse>(
    {
      url: `/session/load-user-session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loadUserSessionRequest,
      signal,
    },
    options,
  );
};

export const getLoadUserSessionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loadUserSession>>,
    TError,
    { data: LoadUserSessionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loadUserSession>>,
  TError,
  { data: LoadUserSessionRequest },
  TContext
> => {
  const mutationKey = ["loadUserSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loadUserSession>>,
    { data: LoadUserSessionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return loadUserSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoadUserSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof loadUserSession>>
>;
export type LoadUserSessionMutationBody = LoadUserSessionRequest;
export type LoadUserSessionMutationError = HTTPValidationError;

/**
 * @summary Load user session
 */
export const useLoadUserSession = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof loadUserSession>>,
      TError,
      { data: LoadUserSessionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof loadUserSession>>,
  TError,
  { data: LoadUserSessionRequest },
  TContext
> => {
  const mutationOptions = getLoadUserSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
